// extracted by mini-css-extract-plugin
export default {"outer":"Spinner__outer___aItin","text":"Spinner__text___PGOX5","flex-item":"Spinner__flex-item___j1dJe","lds-ripple":"Spinner__lds-ripple___jz5_T"};